import type {
  ProductPresetSubtype,
  ProductPresetSubtypeCatalog,
} from './types';
import { getProductPresetSubtypeDescription } from './catalog-descriptions';

type ProductPresetSubtypeDefinition = Omit<
  ProductPresetSubtype,
  'description' | 'imageUrl'
>;
type ProductPresetSubtypeWithOptionalImage = Omit<
  ProductPresetSubtype,
  'description'
>;

export function subtype(
  id: string,
  label: string,
  firstInvariant: string,
  secondInvariant: string,
  ...otherInvariants: string[]
): ProductPresetSubtypeDefinition {
  return {
    id,
    label,
    invariants: [firstInvariant, secondInvariant, ...otherInvariants],
  };
}

export function subtypeCatalog(
  parentKey: string,
  parentNames: readonly [string, ...string[]],
  subtypes: readonly ProductPresetSubtypeWithOptionalImage[]
): ProductPresetSubtypeCatalog {
  return {
    parentKey,
    parentNames,
    subtypes: subtypes.map((subtype) => ({
      ...subtype,
      description: getProductPresetSubtypeDescription(parentKey, subtype.id),
    })),
  };
}

export function withSubtypeImages(
  parentKey: string,
  subtypes: readonly ProductPresetSubtypeDefinition[]
): ProductPresetSubtypeWithOptionalImage[] {
  return subtypes.map((subtype) => ({
    ...subtype,
    imageUrl: `/product-preset-subtypes/${parentKey}/${subtype.id}.png`,
  }));
}
